import React, { useRef, useState } from "react";
import {
  Stack,
  ListItem,
  ListItemText,
  Button,
  Modal,
  Box,
  Card,
  List,
  Typography,
  IconButton,
  ListSubheader
} from "@mui/material";
import SearchField from "./SearchField";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_COMPANIES, FETCH_COMPANIES_2, SAVE_COMPANIES } from "../../constant/Apipath";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import Removeduplicates from "./Removeduplicate";
import CloseIcon from "@mui/icons-material/Close";
import { English } from "../../constant/EnglishFallback";
import { setShowalert } from "../../redux/actions/actions";
const AddCompanyModal = ({ open, onClose, from, onCompanySelect }) => {

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;

  const debounceTimeout = useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSubmitLoading, setShowSubmitLoading] = useState(false);

  const isFromPostAJob = from === "post-a-job"

  const {
    TEXT_ADD_COMPANY_LABEL = English?.AddCompanyModal?.TEXT_ADD_COMPANY_LABEL,
    TEXT_COMPANY_NAME = English?.AddCompanyModal?.TEXT_COMPANY_NAME,
    BUTTON_ADD = English?.AddCompanyModal?.BUTTON_ADD,
    TEXT_EXISTING_COMPANY = English?.AddCompanyModal?.TEXT_EXISTING_COMPANY,
    BUTTON_VIEW = English?.AddCompanyModal?.BUTTON_VIEW
  } = multiLanguageData?.AddCompanyModal || {};

  const getData = async (searchTerm) => {
    try {
      setIsLoading(true);

      // OLD API: FETCH_COMPANIES (commented, do not delete)
      // const obj = {
      //   PageNr: 1,
      //   NrOfRecPerPage: 20,
      //   IncludeRecordNr: true,
      //   SearchList: [
      //     {
      //       name: searchTerm,
      //       manufacturer: false
      //     }
      //   ],
      //   SortList: [{ FieldName: "Name", Direction: "ASC" }],
      //   FetchAllowedRecordsOnly: true,
      //   DoNotSearchInSystemFields: true
      // };
      // const res = await Postrequestcall(FETCH_COMPANIES, obj, loginData?.accessToken);

      // NEW API: FETCH_COMPANIES_2 (active)
      const obj = {
        UserId: currentUserId,
        SearchString: searchTerm,
        PageNumber: 1,
        PageSize: 20,
        Manufacturer: false,
        Id: 0
      };
      const res = await Postrequestcall(FETCH_COMPANIES_2, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      const updatedCode = await Removeduplicates(resData, "name");
      setData(() => updatedCode);
    } catch (error) {
      console.log("getData-> Error While Fetching Companies: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const showAddBtn = (value) => {
    const searchData = data.filter((i) => i.name.toUpperCase() === value.toUpperCase());
    return searchData?.length === 0 ? true : false;
  };

  const onViewClick = (item) => {
    if (!item?.id) return null;
    if (isFromPostAJob) {
      onCompanySelect(item);
      onClose();
      return;
    }
    navigate(`company/${item?.id}`);
  };

  const handleAddNewCompany = async () => {
    try {
      setShowSubmitLoading(true);
      const saveObject = {
        userId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            Name: searchTerm,
            ModifiedBy: Number(currentUserId),
            RecordStatusId: 1,
            Manufacturer: false
          }
        ]
      };
      const res = await Postrequestcall(SAVE_COMPANIES, saveObject, loginData?.accessToken);
      if (res?.data?.data && res?.data?.data[0]?.objData?.id) {
        navigate(`/company/${res.data.data[0].objData.id}`);
      } else {
        throw new Error("Failed to add company");
      }
    } catch (error) {
      console.log("handleAddNewCompany-> Error While Adding New Company: ", error);
      dispatch(setShowalert({
        showAlert: true,
        title: "Error",
        text: "Something went wrong while adding the company. Please try again."
      }));
    } finally {
      setShowSubmitLoading(false);
      onClose();
    }
  };

  return (
    <Modal open={open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6"> {isFromPostAJob ? "Company" : TEXT_ADD_COMPANY_LABEL}</Typography>
          <IconButton onClick={() => onClose()}>
            <CloseIcon />
          </IconButton>
        </Box>
        <SearchField
          value={searchTerm}
          onChange={(value) => {
            setIsLoading(true);
            const searchValue = value;
            setSearchTerm(searchValue);
            if (debounceTimeout.current) {
              clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
              getData(value, 1);
            }, 1000);
          }}
          onSubmit={() => {
            setSearchTerm(searchTerm);
            getData(searchTerm, 1);
          }}
          placeholder={TEXT_COMPANY_NAME}
          size={"small"}
        />
        <Box
          sx={{
            marginTop: "10px",
            paddingBottom: "10px",
            height: "450px",
            overflow: "auto",
            scrollbarWidth: "none"
          }}>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: 440
              }}>
              <Loader />
            </div>
          ) : (
            <>
              {searchTerm.trim().length > 1 && showAddBtn(searchTerm) && !isFromPostAJob && (
                <Card className="pagelist-content" sx={{ marginBottom: 1 }}>
                  <ListItem
                    secondaryAction={
                      <Button
                        loading={showSubmitLoading}
                        color="primary"
                        variant="contained"
                        size="small"
                        onClick={handleAddNewCompany}>
                        {BUTTON_ADD}
                      </Button>
                    }>
                    <ListItemText primary={searchTerm} />
                  </ListItem>
                </Card>
              )}

              {searchTerm === "" ? null : (
                <>
                  {data.length > 0 ? (
                    <List disablePadding>
                      {!isFromPostAJob && <ListSubheader sx={{ pl: 0 }}>{TEXT_EXISTING_COMPANY}</ListSubheader>}
                      <Stack gap={1}>
                        {data?.map((item, index) => {
                          return (
                            <Card
                              key={index.toString()}
                              className="pagelist-content"
                              sx={{ marginTop: "0px" }}>
                              <ListItem
                                sx={{ m: 0 }}
                                key={index.toString()}
                                secondaryAction={
                                  <Button
                                    color="primary"
                                    variant="outlined"
                                    size="small"
                                    onClick={() => onViewClick(item)}>
                                    {isFromPostAJob ? "Select" : BUTTON_VIEW}
                                  </Button>
                                }>
                                <ListItemText primary={item.name} />
                              </ListItem>
                            </Card>
                          );
                        })}
                      </Stack>
                    </List>
                  ) : (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                      <Typography color="text.secondary">
                        No companies found matching your search
                      </Typography>
                    </Box>
                  )}
                </>
              )}
            </>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default AddCompanyModal;
